(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5622],{

/***/ 68116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/facebook-marketplace-shipping/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-03-29",
      tag: "Facebook Marketplace",
      title: "Understand How Facebook Marketplace Shipping Works",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Almost anyone and everyone nowadays has a Facebook account or at least knows what the platform is all about. For active users, the Facebook marketplace is where users can buy and sell items of their choice. Before this, people utilized Facebook Groups to buy, sell, trade, and barter before the marketplace was launched. For example, you might create a garage sale-style group where people in your neighborhood could post stuff for sale and hunt for products from others. However, because it was a bit more tedious, Facebook saw an opportunity and created the marketplace to provide a far more simplified experience."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How it Works"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The way the Facebook marketplace works is simple enough. It starts with sellers taking a photo of their item (or uploading one from their camera roll), inputting a product name, description, and price, confirming their location, and then choosing a category. From there, you can then publish it so that anyone in your area who is looking for anything similar can find it and contact you if they want to buy it."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Setting up Shipping on Your Account"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The next step you need to do is set up shipping for your listing. Once you've described all of your items in your description, simply click Next on the listing details page to proceed to the next stage in the listing process. You'll need to submit your legal name, date of birth, and mailing address on the shipping page. Because you will not be making this purchase through a traditional in-person private sale, you will additionally need to input your bank account details. Your earnings from Facebook marketplace sales will be automatically paid into your account."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Shipping Charges"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When you sell something on the Marketplace that requires shipping, one of the good things about it is choosing who pays for it during the listing preparation process. Depending on how you've set up your ad, the shipping can be paid by you or the buyer. Facebook will take the shipping charges from your payment if you choose to pay for them. Keep this in mind, and Facebook's selling fee charge of 5% with a $0.40 minimum per order."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Eligible Items for Shipping"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Sellers like you can only sell specific items on the Marketplace with shipping and checkout. This includes items priced between $5 and $500, which can be new or used and is accurately listed with the best item description. Here are the following categories that the Facebook marketplace allow:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Classifieds."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Clothing & Accessories."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Deals."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Electronics."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Entertainment."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Family."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Hobbies."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Home & Garden."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Housing."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Vehicles."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Shipping Items to the Buyer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Once a buyer has placed an order, you'll have three business days to dispatch the order and update the tracking information on the Facebook marketplace. When it comes to who pays for shipping on Facebook Marketplace, you have three alternatives. You can charge your customer for shipping by including it in the order total, or you can also have Facebook pay for delivery by deducting it from your sales proceeds. And alternatively, you can pay for shipping yourself."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When buying or selling shipping items on Marketplace, keep the following tips for sellers in mind: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Before you put something up for sale, be sure it complies with Facebook's Commerce Policies."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You should never dispatch an item until you have received the complete payment."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Ensure your buyer understands the shipping timeline, carrier (i.e., FedEx), delivery status, and tracking information."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Consider utilizing a payment method that offers purchase protection, and make sure you read the terms of service to determine if your transaction is covered."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What is the Top Shipper badge, and how to obtain it?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The Top Shipper badge means that a seller has used Facebook marketplace shipping for at least 60 days and completed at least ten transactions per month for the previous two months. To get the badge, you must also have the following:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "For shipped orders, an average rating of 4.5-star is required to be based on 20 or more ratings."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The non-buyer cancellation rate is limited to 3%."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The chargeback rate is capped at 1%."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Missed Handling Rate is limited to 1.5 percent."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Claim Escalation Rate is capped at 1%."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Shipping Performance Metrics Calculation"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When you sell on Marketplace with shipping, your performance is determined by the following:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Cancellation Rate:"
          }), " The proportion of your orders that you or Facebook canceled if you didn't ship within seven days. This does not contain any orders that are currently pending."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Missed Handling Rate:"
          }), " This is the proportion of your orders dispatched or canceled more than three days after they were placed. This does not contain any orders that are currently pending."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Buyer Rating on Prior Shipped Transactions:"
          }), " This is the average buyer rating on your previous shipped transactions (on 20 or more ratings)."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Chargeback Rate:"
          }), " This refers to the percentage of your orders successfully charged back by the buyer through their payment method. Pending orders are not included in this rate."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Claim Escalation Rate:"
          }), " This rate is the proportion of your orders that had a purchase protection claim escalated to Facebook, either as a result of automatic detection of a lack of seller response or as a result of purchasers who were not happy after receiving a seller response. This does not contain any orders that are currently pending."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to exclude an order when calculating your Cancellation Rate"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Cancellation Rate and Missed Handling Rate influence your shipment performance on the Marketplace. So you should strive to have a cancellation rate of less than 10%, so make sure to exclude orders in your cancellation rate you can refer to the Insights section. Here you can track your shipping performance to better understand how well you're doing so you can provide the best possible experience for your consumers on the platform."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In any case that you would like to request a review when you don't agree with your shipping performance, you can appeal the decision by doing the following:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tap Menu on the Facebook app."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select Marketplace from the menu bar"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "After that, tap Insights."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Then tap the order you want to appeal."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Request a review by tapping the button."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Then follow the directions on the screen."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Within two days, Facebook will send you an email with an update on the status of your appeal."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How do sellers get paid when they sell something with shipping on the platform?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Your payout will be processed within five business days of Facebook receiving your buyer's delivery confirmation, or 15 to 20 business days after you enter the tracking information. This final deadline ensures that you are paid even if the delivery confirmation takes longer than expected."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/facebook-marketplace-shipping.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Understand How Facebook Marketplace Shipping Works"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Familiarize yourself with the ins and out of shipping on the Facebook marketplace and learn some best-kept tips to guide you along the way."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/facebook-marketplace-shipping"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/facebook-marketplace-shipping"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Understand How Facebook Marketplace Shipping Works"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Familiarize yourself with the ins and out of shipping on the Facebook marketplace and learn some best-kept tips to guide you along the way."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "March 29th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "March 29th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Facebook Marketplace"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 63739:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/facebook-marketplace-shipping",
      function () {
        return __webpack_require__(68116);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(63739); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);